import {Component, Input, OnInit} from '@angular/core';
import {SessionStatusCode} from '../../../../core/enums/session-status-code.enum';
import {landingPageUrl} from '../../../../core/utils/utils';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {ActivatedRoute, Router} from '@angular/router';
import {AppMode} from '../../../models/app-mode.enum';
import {QueryParamName} from '../../../../core/enums/query-param-name.enum';
import {ApplicationStateService} from '../../../services/application-state.service';
import {UrlParamsService} from '../../../../core/services/impl/url-params.service';
import {SessionStorage} from '../../../../core/services/global/storage/session-storage.service';

@Component({
  selector: 'app-next-notification',
  templateUrl: './next-notification.component.html'
})
export class NextNotificationComponent implements OnInit {

  @Input() code: SessionStatusCode;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() descriptions: string[];
  @Input() imageSrc: string;
  @Input() imageSrcMobile: string;
  @Input() loading: boolean = false;
  @Input() sessionMessage: string;
  @Input() buttonLabel: string;
  @Input() cssClassSuffix: string;

  get processInfoVisible(): boolean {
    return this.loading || isNotNullOrUndefined(this.sessionMessage);
  }

  constructor(private stateService: ApplicationStateService,
              private urlParamsService: UrlParamsService,
              private sessionStorage: SessionStorage,
              private router: Router,
              private route: ActivatedRoute) { }

  ngOnInit(): void {
  }

  onButtonClick(): void {
    switch (this.code) {
      case SessionStatusCode.PAYMENT_CANCELED:
        this.initNewOfferProcessCompleted();
        break;
      case SessionStatusCode.REGISTER_POLICY_ERROR:
        this.redirectToLP();
        break;
      default:
        console.warn(`Notification button action for status code ${this.code} is not supported.`);
    }

  }

  private initNewOfferProcessCompleted() {
    this.stateService.mode = AppMode.NOTIFICATIONS;
    const context = this.urlParamsService.getQueryParam(QueryParamName.CONTEXT);
    this.sessionStorage.clear();
    this.router.navigate(['/'], {
      queryParams: {
        [QueryParamName.CONTEXT]: context
      },
      relativeTo: this.route
    });
    setTimeout(() => window.location.reload(), 0);
  }

  private redirectToLP(): void {
    window.open(landingPageUrl(), '_blank');
  }

}
